module.exports = __webpack_public_path__ + "static/media/image_red@2x-min.e3f1694d.jpg";